import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Grid } from '@applyboard/ui-components';
var Row = function Row(props) {
  return /*#__PURE__*/React.createElement(Grid, _extends({
    item: true,
    container: true,
    xs: 12,
    style: {
      padding: '0 0 16px 0'
    }
  }, props), props.children);
};
export default Row;